/**
 * Optimized hero image URLs in multiple formats and responsive sizes
 * Generated: 2026-05-07
 * Original: 2048x1649, 471KB
 * Optimized: 480w-1440w in AVIF, WebP, JPEG
 */

export const HERO_IMAGES_OPTIMIZED = {
  // 480px width - Mobile
  mobile: {
    avif: "https://d2xsxph8kpxj0f.cloudfront.net/310519663505843393/2RHpeR2ZmtCHr4YUeyUmbN/hero-480w_b6f0e8e9.avif",
    webp: "https://d2xsxph8kpxj0f.cloudfront.net/310519663505843393/2RHpeR2ZmtCHr4YUeyUmbN/hero-480w_60b61adc.webp",
    jpeg: "https://d2xsxph8kpxj0f.cloudfront.net/310519663505843393/2RHpeR2ZmtCHr4YUeyUmbN/hero-480w_ff6a7be3.jpg",
  },
  // 768px width - Tablet
  tablet: {
    avif: "https://d2xsxph8kpxj0f.cloudfront.net/310519663505843393/2RHpeR2ZmtCHr4YUeyUmbN/hero-768w_e8a42a94.avif",
    webp: "https://d2xsxph8kpxj0f.cloudfront.net/310519663505843393/2RHpeR2ZmtCHr4YUeyUmbN/hero-768w_eb43b26b.webp",
    jpeg: "https://d2xsxph8kpxj0f.cloudfront.net/310519663505843393/2RHpeR2ZmtCHr4YUeyUmbN/hero-768w_69b7bad9.jpg",
  },
  // 1024px width - Desktop
  desktop: {
    avif: "https://d2xsxph8kpxj0f.cloudfront.net/310519663505843393/2RHpeR2ZmtCHr4YUeyUmbN/hero-1024w_018a97a5.avif",
    webp: "https://d2xsxph8kpxj0f.cloudfront.net/310519663505843393/2RHpeR2ZmtCHr4YUeyUmbN/hero-1024w_4bfb1ba9.webp",
    jpeg: "https://d2xsxph8kpxj0f.cloudfront.net/310519663505843393/2RHpeR2ZmtCHr4YUeyUmbN/hero-1024w_9ee7761b.jpg",
  },
  // 1440px width - Large desktop
  large: {
    avif: "https://d2xsxph8kpxj0f.cloudfront.net/310519663505843393/2RHpeR2ZmtCHr4YUeyUmbN/hero-1440w_b7b31685.avif",
    webp: "https://d2xsxph8kpxj0f.cloudfront.net/310519663505843393/2RHpeR2ZmtCHr4YUeyUmbN/hero-1440w_175e2e05.webp",
    jpeg: "https://d2xsxph8kpxj0f.cloudfront.net/310519663505843393/2RHpeR2ZmtCHr4YUeyUmbN/hero-1440w_a5734347.jpg",
  },
};

// Image dimensions (width x height)
export const HERO_DIMENSIONS = {
  480: { width: 480, height: 387 },
  768: { width: 768, height: 619 },
  1024: { width: 1024, height: 825 },
  1440: { width: 1440, height: 1161 },
};

// Fallback image (JPEG for older browsers)
export const HERO_IMAGE_FALLBACK = "https://d2xsxph8kpxj0f.cloudfront.net/310519663505843393/2RHpeR2ZmtCHr4YUeyUmbN/hero-1440w_a5734347.jpg";
